import { inject, observer } from 'mobx-react'

import Skeleton from 'components/Skeleton'
import styled from 'styled-components'
import { Page } from 'utils/constants'

const StyledContainer = styled.div`
	max-width: 1024px;
	display: block;
	margin-left: auto;
	margin-right: auto;
`

const StyledTitle = styled.h2`
	text-transform: uppercase;
`

interface LegalProps {
	title: string
	content: string
}

const Legal = inject(
	'Infra',
	'User'
)(
	observer(({ title, content }: LegalProps) => (
		<Skeleton page={Page.LEGAL} showLogo showCustomTitle showHeader>
			<StyledContainer>
				<StyledTitle data-testid="legal-title">{title}</StyledTitle>
			</StyledContainer>
			<StyledContainer>
				<p data-testid="legal-text-content">{content}</p>
			</StyledContainer>
		</Skeleton>
	))
)

export default Legal
